import { render, staticRenderFns } from "./goodCard.vue?vue&type=template&id=44b6afd9&scoped=true"
import script from "./goodCard.vue?vue&type=script&lang=js"
export * from "./goodCard.vue?vue&type=script&lang=js"
import style0 from "./goodCard.vue?vue&type=style&index=0&id=44b6afd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b6afd9",
  null
  
)

export default component.exports